export default {
    dirty: false,
    lastUpdate: 0,
    filteredItems: undefined,
};
